export enum MenuStates {
  Picker = "picker",
  ProSeries = "proSeries",
  FullMenu = "fullMenu",
  PSSeat = "psSeats",
  PSArmor = "psArmor",
}
